import {Container} from '@inlet/react-pixi';
import React, {RefObject} from 'react';
import {Image} from '@gongxigames/framework/core/fragments/react/components/Image';
import {IHitArea, Container as PixiContainer} from 'pixi.js';
import {AUTOMATION_META, AutomationMeta} from '@gongxigames/framework/core/fragments/Autotest';

enum ButtonState {
    UP = 'up',
    DOWN = 'down',
    OVER = 'over',
    DISABLED = 'disabled'
}

export type ButtonWithIconProps = {
    onClick: Function;
    disabled?: boolean;
    visible?: boolean;
    name?: string;
    x?: number;
    y?: number;
    hitArea?: IHitArea;
    icon: {
        up: string;
        down?: string;
        over?: string;
        disabled?: string;
    };
};

type ReactButtonState = {
    buttonState: ButtonState;
    over: boolean;
};

export class ButtonWithIcon extends React.Component<ButtonWithIconProps, ReactButtonState> {
    btnRef: RefObject<PixiContainer>;

    constructor(props: ButtonWithIconProps) {
        super(props);

        this.state = {
            buttonState: ButtonState.UP,
            over: false
        };

        this.btnRef = React.createRef();
    }

    protected onPointerDown(): void {
        this.setState({buttonState: ButtonState.DOWN});
    }

    protected onPointerUp(): void {
        this.changeUpState();
    }

    protected onPointerOver(): void {
        this.setState({over: true});
        this.changeUpState();
    }

    protected onPointerOut(): void {
        this.setState({over: false});
        this.changeUpState();
    }

    protected changeUpState(): void {
        this.setState(state => {
            return {buttonState: state.over ? ButtonState.OVER : ButtonState.UP};
        });
    }

    public render(): JSX.Element {
        const {
            icon,
            disabled,
            name = 'ButtonWithIcon',
            hitArea,
            ...containerProps
        } = this.props;
        let {buttonState} = this.state;

        buttonState = disabled ? ButtonState.DISABLED : buttonState;

        const image = icon[buttonState] ?? icon.up;

        if (this.btnRef.current) {
            (this.btnRef.current as any)[AUTOMATION_META] = () => {
                const automationMeta: AutomationMeta = {
                    type: 'button',
                    disabled: !!this.props.disabled,
                    over: this.state.over,
                    pressed: this.state.buttonState === ButtonState.DOWN
                };

                return automationMeta;
            };
        }

        return (
            <Container name={name} {...containerProps}>
                <Image
                    src={image}
                    hitArea={hitArea}
                    interactive={!disabled} buttonMode={!disabled}
                    pointertap={this.props.onClick.bind(this)}
                    pointerdown={this.onPointerDown.bind(this)}
                    pointerup={this.onPointerUp.bind(this)}
                    pointerover={this.onPointerOver.bind(this)}
                    pointerout={this.onPointerOut.bind(this)}
                />
            </Container>
        );
    }
}
